export const module = data => {
  return {
    id: data.id || '',
    name: data.name || '',
    code: data.code || '',
    link: data.link || '',
  };
};
